import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {LovValuesSelectFilterComponent} from "./lov-values-select-filter.component";
import {MultipleSelectFilterModule} from "../../../../../../core/component/multiple-select-filter/multiple-select-filter.module";
import {LovValueUpdateModalModule} from "../lov-value-update-modal/lov-value-update-modal.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        MultipleSelectFilterModule,
        LovValueUpdateModalModule,
    ],
    declarations: [
        LovValuesSelectFilterComponent,
    ],
    exports: [
        LovValuesSelectFilterComponent
    ]
})
export class LovValuesSelectFilterModule {}